import { type SVGProps } from 'react';

export function IconInfo({
  width = 24,
  height = 24,
  ...restProps
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...restProps}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="16" x2="12" y2="12" />
      <line x1="12" y1="8" x2="12.01" y2="8" />
    </svg>
  );
}
